import { MultiSelect } from "react-multi-select-component";
import {Delete, RotateCcw} from "lucide-react";
import {Form} from "react-bootstrap";

type SelectFilterProps<T extends string|number> = {
    label: string,
    value: { value: T, label: string },
    options: { value: T, label: string }[]
    setValue: (values: { value: T, label: string }) => void
    className?: string
}

export const SelectFilter = <T extends string|number>(props: SelectFilterProps<T>) => {
    return (
        <Form.Select
            className={props.className || ''}
            value={props.value.value}
            onChange={e => props.setValue(props.options.find(option => option.value === e.target.value)!)}
        >
            {props.options.map(option => <option value={option.value}>{option.label}</option>)}
        </Form.Select>
    )
}